import * as api from "./client";

export type CompanySummaryListItem = {
  companyId: number;
  companyName: string;
  companySlug: string;
  practiceAreaSlug: string;
  countrySlug: string;
  site: string;
  logoUrl: string | null;
  practiceArea: { name: string; slug: string; id: number } | null;
  practiceGroup: { name: string; slug: string; id: number } | null;
  globalOfficeCount: number | null;
  localOfficeCount: number | null;
  jurisdictionCount: number | null;
  rankingTables: unknown;
  ratings: unknown;
  activeClients: unknown;
  workHighlights: unknown;
  testimonials: unknown;
  comparativeGuides: unknown;
  financials: unknown;
  siteStructureIds: string[];
  publicationId: number | null;
  syncedAt: string | null;
};

export type CompanySummariesListResponse = {
  summaries: CompanySummaryListItem[];
  pagination: {
    total: number;
    limit: number;
    offset: number;
    hasMore: boolean;
  };
  requestId: string | null;
};

type ListParams = {
  search?: string;
  site?: string;
  limit?: number;
  offset?: number;
};

export const companySummaries = {
  getAll: async (params: ListParams = {}): Promise<CompanySummariesListResponse> => {
    const queryParams = new URLSearchParams();
    if (params.search) queryParams.append("search", params.search);
    if (params.site) queryParams.append("site", params.site);
    if (params.limit !== undefined) queryParams.append("limit", String(params.limit));
    if (params.offset !== undefined) queryParams.append("offset", String(params.offset));
    const queryString = queryParams.toString() ? `?${queryParams.toString()}` : "";
    return api.get<CompanySummariesListResponse>(
      `/v1/data-marts/company-summaries/list${queryString}`,
    );
  },
};
